/**
 * Enumerates website routes (pages) at the root path
 *
 * These map 1:1 to Wordpress > ACF > Field Groups > Pages to
 * allow content filtering against pages with some compile
 * time type safety. Do not change the string values without
 * also updating Wordpress and Brain Tab!
 *
 * Entries are purposefully alphabetical to allow for deterministic
 * usage of functions like Object.values()
 */
export enum GknRoutePath {
    ADVOCACY = 'advocacy',
    COMMUNITY = 'community',
    EDUCATION = 'education',
    GKN_STORIES = 'gkn-stories',
    HOME = 'home',
    LOGIN_CALLBACK = 'login/callback',
    PROFILE = 'profile',
    STATUS = 'status',
    RESOURCES = 'resources',
    SUPPORT = 'support',
    SEARCH = 'search',
    SIGNUP = 'sign-up',
    DESIGN = 'design',
}

/** labels for {@link GknRoutePath}. note, not all root pages require a label */
export enum GknRouteLabel {
    ADVOCACY = 'Advocacy',
    ACHIEVERS_LOUNGE = "Achiever's Lounge",
    COMMUNITY = 'Community',
    DESIGN = 'Design',
    EDUCATION = 'Education',
    HOME = 'Home',
    PROFILE = 'Profile',
    RESOURCES = 'Resources',
    SUPPORT = 'Support',
    SEARCH = 'Search Genesys Orchestrators',
}

/**
 * Enumerates child pages in a decouple way from root pages
 * These are not available in Wordpress.
 *
 * Entries are purposefully alphabetical to allow for deterministic
 * usage of functions like Object.values()
 */
export enum ChildPageRoute {
    ACHIEVERS_LOUNGE = 'achievers-lounge',
    APPFOUNDRY = 'appfoundry',
    BOOST_YOUR_KNOWLEDGE_WEBINARS = 'boost-your-knowledge-webinars',
    BOOST_YOUR_KNOWLEDGE_WEBINARS_LIBRARY = 'boost-your-knowledge-webinars-library',
    CAPABILITY_ACCELERATOR = 'capability-accelerator',
    CAPABILITY_ACCELERATOR_AGENT_COPILOT = 'agent-copilot',
    // CAPABILITY_ACCELERATOR_GPR = 'capability-accelerator', // TODO update this in wordpress and match it here
    // CAPABILITY_ACCELERATOR_GPR = 'predictive-routing',
    CAPABILITY_ACCELERATOR_STA = 'speech-text-analytics',
    CAPABILITY_ACCELERATOR_WEB_MESSAGING = 'web-messaging',
    CAPABILITY_ACCELERATOR_WEM = 'wem',
    COMMUNITY_ACTIVITIES = 'community-activities',
    CX_EVOLUTION = 'cx-evolution',
    GENESYS_NEWS_AND_EVENTS = 'genesys-news-and-events',
    ONBOARDING = 'onboarding',
    PRODUCT_KNOWLEDGE = 'product-knowledge',
    ROADMAP_ARCHIVES = 'roadmap-archives',
    SHORT_TRACKS = 'short-tracks',
    STARTER_KITS = 'starter-kits',
    STARTER_KITS_GC = 'genesys-cloud-cx',
    STARTER_KITS_WEM = 'genesys-cloud-wem-ex', // TODO Delete when wem moves to capability accelerators
}

export enum ChildPageRouteLabel {
    CAPABILITY_ACCELERATOR = 'Capability Accelerator',
    // TODO
}

/**
 * Defines paths that are exclusive to Genesys Cloud CX
 * These paths require special handling when switching products
 */
export const GC_EXCLUSIVE_PATHS = {
    APPFOUNDRY: `/${GknRoutePath.RESOURCES}/${ChildPageRoute.APPFOUNDRY}`,
    ONBOARDING: `/${GknRoutePath.RESOURCES}/${ChildPageRoute.ONBOARDING}`,
    CAPABILITY_ACCELERATOR: `/${GknRoutePath.RESOURCES}/${ChildPageRoute.CAPABILITY_ACCELERATOR}`,
    // Add more paths as needed
} as const;
